<template>
  <div class="Wechat_pay container">
    <div class="head_box">
      <div class="logo" v-if="false">
        <router-link to="/" target="_blank">
          <img class="img_item" src="@/assets/img/LOGO.png" alt />
        </router-link>
        <h1>买家具多比·多比多实惠</h1>
      </div>
    </div>
    <div class="content">
      <div class="order">
        <div class="order_left">
          <span class="text">订单号：</span>
          <span>{{orderNo}}</span>
        </div>
        <div class="order_right">
          <span class="o_item">应付金额</span>
          <span class="price o_item">{{Math.ceil($route.query.payFee) | priceValue}}</span>
          <span class="o_item">元</span>
        </div>
      </div>
      <div class="we_chat_box">
        <div class="title_box">
          <div class="title">微信支付</div>
          <div class="time_out" v-if="timeDown>0">
            <span v-show="!errorMsg">
              距离二维码过期还剩
              <span class="col_red">{{timeDown}}</span>
              秒,过期后请刷新页面重新获取二维码。
            </span>
            <span class="font_red" v-show="errorMsg">{{errorMsg}}</span>
          </div>
          <div class="time_out font_red" v-if="timeDown<=0">
            二维码已过期，
            <span class="font_theme com_link" @click="$router.go(0)">刷新</span>
            页面重新获取二维码。
          </div>
        </div>
        <div class="chat_con_box">
          <div class="left_chat">
            <!-- 二维码控件 -->
            <div ref="qrcode" class="QR_code" id="qrcode" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" title>
              <!-- 遮罩层 -->
              <div class="QR_out" v-if="timeDown<=0"></div>
              <div class="QR_test com_link" v-if="timeDown<=0" @click="$router.go(0)">获取失败 点击重新获取二维码</div>
            </div>
            <div class="img_btn">
              <div class="img_box">
                <img v-lazy="require('@/assets/img/qritr.png')" alt />
              </div>
              <div class="test">
                请使用微信扫一扫
                扫描二维码支付
              </div>
            </div>
          </div>
          <div class="right_chat">
            <img v-lazy="require('@/assets/img/phone.jpg')" alt />
          </div>
        </div>
        <div class="back">
          <router-link :to="{path:path,query:$route.query}">
            <i class="el-icon-arrow-left"></i> 选择其他支付方式
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  metaInfo: { title: "微信支付" },
  name: "wechatPay",
  props: {
    PageOrderPay: {
      type: Function,
      default: () => {},
    },
    GetOrderPayState: {
      type: Function,
      default: () => {},
    },
    PtPageOrderPay: {
      type: Function,
      default: () => {},
    },
    SinglePageOrderPay: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loading: true,
      id: null,
      orderNo: null,
      codeUrl: null,
      timeDown: 60,
      ajaxInterval: null,
      errorMsg: "",
      path: "/payType",
    };
  },
  mounted() {
    // console.log(this.$route.query);
    if (!this.$route.query.id) {
      this.timeDown = 0;
      this.loading = false;
      return;
    }
    this.id = this.$route.query.id;
    this.orderNo = this.$route.query.orderNo;
    // console.log(this.$route.query);
    if (this.$route.query.come === "order") {
      this.singleGetCodeUrl();
      this.path = "/orderPay";
      return;
    }
    if (this.$route.query.come === "plate") {
      this.ptGetCodeUrl();
      this.path = "/platePay";
      return;
    }
    this.getCodeUrl();
    this.path = "/payType";
  },
  beforeDestroy() {
    //清除轮询
    clearInterval(this.ajaxInterval);
    this.ajaxInterval = null;
  },
  methods: {
    getCodeUrl() {
      let params = {
        payWay: 2,
        orderBatchId: this.id,
        payFee: Math.ceil(parseFloat(this.$route.query.payFee)),
        aloneDo: true,
      };
      this.PageOrderPay(params).then((res) => {
        // console.log("微信支付接口获取二维码", res);
        if (res.isSuccess === 0) {
          this.errorMsg = res.message || "发生异常";
        } else {
          this.codeUrl = res.data[0].codeUrl;
          // 生成二维码
          this.createQR(this.codeUrl);
          // 开启倒计时
          this.setTimeDown();
          // ajax轮询获取用户扫码状态
          this.ajaxInterval = setInterval(() => {
            this.getState(res.data[0].payOrderNo);
          }, 3000);
        }
      });
    },
    createQR(code) {
      let qrcode = new QRCode("qrcode", {
        width: 300,
        height: 300, // 高度
        text: code, // 二维码内容
        render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      // 不展示title
      this.$refs.qrcode.title = "";
      // 关闭loading
      this.loading = false;
    },
    setTimeDown() {
      this.timeDown = 60;
      let interval = setInterval(() => {
        this.timeDown--;
        if (this.timeDown <= 0) {
          clearInterval(interval);
          interval = null;
        }
      }, 1000);
    },
    getState(payOrderNo) {
      let params = {
        payWay: 2,
        payOrderNo,
      };
      this.GetOrderPayState(params).then((res) => {
        // console.log("查询交易单支付状态", res);
        if (res.data[0].isPay === 1) {
          //清除轮询
          clearInterval(this.ajaxInterval);
          this.ajaxInterval = null;
          // 页面跳转
          let newUrl = this.$router.resolve({
            name: "payDown",
            query: {
              out_trade_no: payOrderNo,
              come: this.$route.query.come,
            },
          });
          window.open(newUrl.href, "_self");
        }
      });
    },
    ptGetCodeUrl() {
      let params = {
        payWay: 2,
        orderBatchId: this.id,
        payFee: Math.ceil(parseFloat(this.$route.query.payFee)),
        aloneDo: true,
      };
      this.PtPageOrderPay(params).then((res) => {
        // console.log("微信支付接口获取二维码", res);
        if (res.isSuccess === 0) {
          this.errorMsg = res.message || "发生异常";
        } else {
          this.codeUrl = res.data[0].codeUrl;
          // 生成二维码
          this.createQR(this.codeUrl);
          // 开启倒计时
          this.setTimeDown();
          // ajax轮询获取用户扫码状态
          this.ajaxInterval = setInterval(() => {
            this.getState(res.data[0].payOrderNo);
          }, 3000);
        }
      });
    },
    singleGetCodeUrl() {
      let params = {
        payWay: 2,
        orderId: this.id,
        payFee: Math.ceil(parseFloat(this.$route.query.payFee)),
        aloneDo: true,
      };
      this.SinglePageOrderPay(params).then((res) => {
        // console.log("微信支付接口获取二维码", res);
        if (res.isSuccess === 0) {
          this.errorMsg = res.message || "发生异常";
        } else {
          this.codeUrl = res.data[0].codeUrl;
          // 生成二维码
          this.createQR(this.codeUrl);
          // 开启倒计时
          this.setTimeDown();
          // ajax轮询获取用户扫码状态
          this.ajaxInterval = setInterval(() => {
            this.getState(res.data[0].payOrderNo);
          }, 3000);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.Wechat_pay {
  margin-bottom: 42px;
  .head_box {
    margin-top: 37px;
    margin-bottom: 43px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .logo {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
      .img_item {
        width: auto;
        height: auto;
      }
      h1 {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: 5.6px;
      }
    }
  }
  .content {
    height: 658px;
    // border: 1px solid #e4e4e4;
    box-sizing: border-box;
    padding: 0px 0 75px;
    color: #191919;
    .order {
      width: 1006px;
      margin: 0 auto;
      margin-bottom: 60px;
      position: relative;
      .order_left {
        padding-right: 200px;
        font-size: 14px;
        color: #333333;
        word-wrap: break-word;
        .text {
          display: inline-block;
        }
      }
      .order_right {
        position: absolute;
        right: 0px;
        top: 0px;
        font-size: 12px;
        color: #666666;
        display: flex;
        align-items: center;
        max-width: 200px;
        overflow: hidden;
        .price {
          color: #e31613;
          font-size: 18px;
        }
        .o_item {
          display: inline-block;
          padding-right: 4px;
        }
      }
    }
    .we_chat_box {
      width: 1006px;
      height: 508px;
      box-sizing: border-box;
      box-shadow: 0 6px 32px rgba(0, 0, 0, 0.13);
      margin: 0 auto;
      padding: 15px 20px 0;
      .title_box {
        display: flex;
        line-height: 24px;
        .title {
          font-size: 18px;
          margin-right: 87px;
        }
        .time_out {
          font-size: 12px;
        }
        .font_red {
          color: #e31613;
        }
        .font_theme {
          color: #67a4ff;
        }
        .col_red {
          color: #ff0000;
        }
      }
      .chat_con_box {
        width: 646px;
        height: 426px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .left_chat {
          width: 300px;
          height: 100%;
          box-sizing: border-box;
          padding-top: 20px;
          .QR_code {
            width: 100%;
            height: 300px;
            box-sizing: border-box;
            margin-bottom: 20px;
            position: relative;
            .QR_out {
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              background: rgba(0, 0, 0, 1);
            }
            .QR_test {
              position: absolute;
              width: 216px;
              height: 30px;
              line-height: 30px;
              box-sizing: border-box;
              top: 50%;
              left: 50%;
              transform: translate(-50%);
              font-size: 12px;
              background: #fff;
              color: #666;
              padding: 0 28px;
              text-align: center;
            }
          }

          .img_btn {
            width: 100%;
            height: 60px;
            box-sizing: border-box;
            background-color: #ff7674;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 50px;
            .img_box {
              width: 44px;
              height: 44px;
            }
            .test {
              width: 120px;
              font-size: 14px;
              color: #fff;
              line-height: 22px;
            }
          }
        }
        .right_chat {
          width: 324px;
          height: 100%;
        }
      }
    }
  }
}
</style>